import { render } from "./ReceivePayment.vue?vue&type=template&id=558ff623&scoped=true"
import script from "./ReceivePayment.vue?vue&type=script&lang=js"
export * from "./ReceivePayment.vue?vue&type=script&lang=js"

import "./ReceivePayment.vue?vue&type=style&index=0&id=558ff623&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558ff623"]])

export default __exports__